import { TableBody,TableCell, TableContainer, TableHead,TableRow} from "@mui/material";
  import { Table } from "react-bootstrap";
  import CurrencyFormat from 'react-currency-format';
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { formatCustomDate } from "../../helpers/formatCustomDate";



const BillPaymentMade = (props) => {

    return ( 

        <>
          <div className="mt-2  ">
  
  <TableContainer className="mt-3 w-full border mb-5 bg-blue-50">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <colgroup>
                    <col style={{width:'20%'}}/>
                    <col style={{width:'20%'}}/>
                    <col style={{width:'20%'}}/>
                    <col style={{width:'20%'}}/>
                    <col style={{width:'20%'}}/>
                </colgroup>
              <TableHead style={{ backgroundColor: "#F1F1F1" }}>
                <TableRow>
                  <TableCell>Payment Ref</TableCell>
                  <TableCell>Payment Date</TableCell>
                  <TableCell> Payment Through </TableCell>
                  <TableCell> Payment Made </TableCell>
                  <TableCell> Status </TableCell>
         
                </TableRow>
              </TableHead>
  
              <TableBody className=" mb-3">
                {props?.payments?.map((item, i) => {
                  return (
                    <TableRow className="border-1"
                      key={i}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="left">{item.Payment_Ref_No} </TableCell>
                      <TableCell align="left">{formatCustomDate(item.Payment_Date)}  </TableCell>
                      <TableCell align="center">
                        {item.Payment_Through_Name} 
                        </TableCell>
                  
                      <TableCell align="left">
                        <CurrencyFormat value={formatCustomNumber(item.Payment_Amount)}
                         displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                       </TableCell>
                
                      <TableCell align="left">
                      <span className="font-bold border-2 p-2" >{item.Payment_Status_Name} </span>
                   
                       </TableCell>
                
               
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
  </div>
      
        
        </>
     );
}
 
export default BillPaymentMade;